export function Icon({ icon, layoutClassName = undefined }) {
  return <span className={layoutClassName} dangerouslySetInnerHTML={{ __html: icon }} />
}
